// components/TipsPractices.jsx
import React, { useState, useEffect } from 'react';
import '../CSS/LandingTipsPractices.css';

const CapmTipsPractices = () => {
    // Données avec les iframes LinkedIn (modifié width à 100%)
    const articles = [
        {
            id: 1,
            category: "ACTUALITÉ",
            date: "2025",
            title: "Signature du communiqué conjoint",
            description: "Signature du communiqué conjoint portant établissement des relations diplomatiques entre les deux nations.",
            color: "#94bf3e",
            iframe: `<iframe src="https://www.linkedin.com/embed/feed/update/urn:li:share:7419781672088408064?collapsed=1" height="669" width="100%" frameborder="0" allowfullscreen="" title="Post intégré"></iframe>`
        },
        {
            id: 2,
            category: "PMI BÉNIN",
            date: "2025",
            title: "PMI Chapter Bénin & Inovact : Partenariat Stratégique",
            description: "Découvrez notre partenariat avec PMI Chapter Bénin pour renforcer les compétences en gestion de projet au Bénin.",
            color: "#0a3764",
            iframe: `<iframe src="https://www.linkedin.com/embed/feed/update/urn:li:share:7419785539395960834?collapsed=1" height="635" width="100%" frameborder="0" allowfullscreen="" title="Post intégré"></iframe>`
        },
        {
            id: 3,
            category: "ACTUALITÉ",
            date: "2025",
            title: "Diplomatie : Îles Salomon et République du Bénin",
            description: "Établissement des relations diplomatiques entre les Îles Salomon et la République du Bénin.",
            color: "#0a3764",
            iframe: `<iframe src="https://www.linkedin.com/embed/feed/update/urn:li:share:7419786960879194112?collapsed=1" height="655" width="100%" frameborder="0" allowfullscreen="" title="Post intégré"></iframe>`
        },
        {
            id: 4,
            category: "ACTUALITÉ",
            date: "2025",
            title: "Diplomatie : Îles Salomon et République du Bénin",
            description: "Établissement des relations diplomatiques entre les Îles Salomon et la République du Bénin.",
            color: "#0a3764",
            iframe: `<iframe src="https://www.linkedin.com/embed/feed/update/urn:li:share:7419788901763936256?collapsed=1" height="551" width="100%" frameborder="0" allowfullscreen="" title="Post intégré"></iframe>`
        },
        {
            id: 5,
            category: "ACTUALITÉ",
            date: "2025",
            title: "Diplomatie : Îles Salomon et République du Bénin",
            description: "Établissement des relations diplomatiques entre les Îles Salomon et la République du Bénin.",
            color: "#0a3764",
            iframe: `<iframe src="https://www.linkedin.com/embed/feed/update/urn:li:share:7419790257925046272?collapsed=1" height="603" width="100%" frameborder="0" allowfullscreen="" title="Post intégré"></iframe>`
        },
        {
            id: 6,
            category: "ACTUALITÉ",
            date: "2025",
            title: "Diplomatie : Îles Salomon et République du Bénin",
            description: "Établissement des relations diplomatiques entre les Îles Salomon et la République du Bénin.",
            color: "#0a3764",
            iframe: `<iframe src="https://www.linkedin.com/embed/feed/update/urn:li:share:7419792687664619520?collapsed=1" height="669" width="100%" frameborder="0" allowfullscreen="" title="Post intégré"></iframe>`
        }
    ];

    const [showAll, setShowAll] = useState(false);
    const displayedArticles = showAll ? articles : articles.slice(0, 3);

    // Charger le SDK Facebook
    useEffect(() => {
        // Vérifier si le script Facebook SDK est déjà chargé
        if (!window.fbAsyncInit) {
            window.fbAsyncInit = function () {
                window.FB.init({
                    xfbml: true,
                    version: 'v19.0'
                });
            };

            // Charger le SDK Facebook
            (function (d, s, id) {
                var js, fjs = d.getElementsByTagName(s)[0];
                if (d.getElementById(id)) return;
                js = d.createElement(s); js.id = id;
                js.src = 'https://connect.facebook.net/fr_FR/sdk.js#xfbml=1&version=v19.0';
                js.defer = true;
                fjs.parentNode.insertBefore(js, fjs);
            }(document, 'script', 'facebook-jssdk'));
        }
    }, []);

    return (
        <section className="landing-tips-practices" id="conseils">
            <div className="landing-contenir">
                <h2 className="landing-section-title">Conseils et bonnes pratiques pour progresser</h2>

                <div className="landing-articles-grid">
                    {displayedArticles.map((article) => (
                        <div
                            key={article.id}
                            className="landing-article-card"
                            style={{}}
                        >
                            {/* <div className="landing-article-meta">
                <span className="landing-article-category">
                  {article.category} | {article.date}
                </span>
              </div> */}

                            <div className="landing-article-content">
                                {/* <h3 className="landing-article-title">{article.title}</h3>
                <p className="landing-article-description">{article.description}</p> */}

                                {/* Intégration LinkedIn */}
                                <div className="landing-facebook-iframe-container">
                                    <div
                                        dangerouslySetInnerHTML={{ __html: article.iframe }}
                                    />
                                </div>
                            </div>

                            <div className="landing-article-footer">
                                <a
                                    href="https://www.linkedin.com/company/inovact"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="landing-read-article-btn"
                                >
                                    SUIVEZ-NOUS SUR LinkedIn
                                </a>
                            </div>
                        </div>
                    ))}
                </div>

                {/* Bouton Voir plus/moins */}
                {articles.length > 3 && (
                    <div className="landing-articles-more">
                        <button
                            className="landing-btn-more-articles"
                            onClick={() => setShowAll(!showAll)}
                        >
                            {showAll ? 'Voir moins d\'articles' : 'Voir plus d\'articles'}
                        </button>
                    </div>
                )}
            </div>
        </section>
    );
};

export default CapmTipsPractices;